"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Space = void 0;
const core_1 = require("@apitable/core");
const message_1 = require("../message");
const datasheet_1 = require("./datasheet");
const view_computed_1 = require("../view_computed");
class Space {
    /**
     * @hidden
     */
    constructor(wCtx) {
        this.wCtx = wCtx;
    }
    /**
     * The unique ID of the space.
     * @returns
     *
     * #### Example
     * ```js
     * console.log(space.id); // => 'spcxxxxxx'
     * ```
     */
    get id() {
        var _a;
        const state = this.wCtx.widgetStore.getState();
        return (_a = state.user) === null || _a === void 0 ? void 0 : _a.spaceId;
    }
    /**
     * The name of the space.
     * @returns
     *
     * #### Example
     * ```js
     * console.log(space.name); // => 'Test Space'
     * ```
     */
    get name() {
        var _a;
        const state = this.wCtx.widgetStore.getState();
        return (_a = state.user) === null || _a === void 0 ? void 0 : _a.spaceName;
    }
    /**
     * Get the active datasheet for the space.
     *
     * @returns
     *
     * #### Example
     * ```js
     * const activeDatasheet = await space.getActiveDatasheetAsync();
     * console.log(activeDatasheet); // => Datasheet
     * ```
     */
    getActiveDatasheetAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const state = this.wCtx.widgetStore.getState();
            const activeDatasheetId = core_1.Selectors.getActiveDatasheetId(state);
            if (activeDatasheetId == null) {
                throw new Error('There are currently no active datasheet');
            }
            (0, view_computed_1.useReferenceCount)(activeDatasheetId, "");
            yield message_1.widgetMessage.fetchDatasheet({ datasheetId: activeDatasheetId });
            return new datasheet_1.Datasheet(activeDatasheetId, this.wCtx);
        });
    }
    /**
     * get select records ids  of the space.
     * @returns
     *
     * #### Example
     * ```js
     * console.log(Space.getSelectRecordIds()); // => 'Test Space'
     * ```
     */
    getSelectRecordIds() {
        const state = this.wCtx.widgetStore.getState();
        return core_1.Selectors.getSelectRecordIds(state);
    }
    /**
     * 监听整个空间的操作
     * @returns
     *
     * #### Example
     * ```js
     * console.log(Space.addActionListener(callback)); // => 'Test Space'
     * ```
     */
    addActionListener(callback) {
        message_1.widgetMessage.onSyncAction(callback);
    }
    /**
     * Get the specified datasheet in the space.
     *
     * @param datasheetId The ID of the datasheet.
     * @returns
     *
     * #### Example
     * ```js
     * const datasheet = await space.getDatasheetAsync('dstxxxxxx');
     * console.log(datasheet); // => Datasheet
     * ```
     */
    getDatasheetAsync(datasheetId) {
        return __awaiter(this, void 0, void 0, function* () {
            //const state = this.wCtx.widgetStore.getState() as unknown as IReduxState;
            //const activeDatasheetId = Selectors.getActiveDatasheetId(state);
            //const overWrite = activeDatasheetId !== datasheetId;
            //await widgetMessage.fetchDatasheet({ datasheetId, overWrite });
            (0, view_computed_1.useReferenceCount)(datasheetId, "");
            return new datasheet_1.Datasheet(datasheetId, this.wCtx);
        });
    }
}
exports.Space = Space;
